<template>
  <div class="orderEdit">
    <div style="display: flex; flex-direction: column; height: 100%">
      <div class="pageNav">
        <i class="goBack el-icon-arrow-left" v-if="editType!='hotline'&&fromPage!='hotline'" @click="handleClose"></i>
        <el-breadcrumb class="breadcrumb" separator="/" v-if="editType!='hotline'&&fromPage!='hotline'">
          <el-breadcrumb-item>{{Language(editType=='examine'?'工单审批':editType=='edit'?'工单跟进':editType=='add'?'新建工单':editType=='info'?'查看工单':editType=='supervise'?'督办工单':'工单回访')}}</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="operateList" v-if="(editType=='edit'||editType=='hotline')&&sFormInfo.status!=8">
          <el-button type="primary" size="mini" plain v-for="(item, index) in buttonList" :key="index" @click="operateFn(item)">{{item}}</el-button>
        </div>
        <div class="operateList" v-if="editType=='supervise'">
          <el-button type="primary" size="mini" plain @click="operateFn('打回')">{{Language('打回')}}</el-button>
          <el-button type="primary" size="mini" plain @click="operateFn('转派')">{{Language('转派')}}</el-button>
          <el-button type="primary" size="mini" plain @click="operateFn('关闭')">{{Language('关闭')}}</el-button>
        </div>
      </div>
      <div class="contentBox pt-15">
        <div class="content-form">
          <div class="orderForm">
            <OrderForm v-if="dialogShow" @saveFn="saveFn" :dialogShow="dialogShow" :sFormInfo="sFormInfo" :editType="editType" :examineId="examineId" :returnId="returnId" 
              :hotlineObj="hotlineObj" ref="sFormInfo"></OrderForm>
          </div>
          <el-tabs v-model="tabsActive" class="notRight">
            <el-tab-pane :label="Language('跟进记录')" name="1" v-if="editType!='hotline'">
              <div style="height:100%;padding: 10px 20px;overflow-y: auto;">
                <el-empty :description="Language('暂无记录')" v-if="!followRecord.length">
                  <i class="iconfont icongongdan font-36" slot="image" style="color:#909399;"></i>
                </el-empty>
                <el-timeline v-else>
                  <el-timeline-item v-for="(item, index) in followRecord" :key="index" type="primary" :timestamp="item.createDate" placement="top">
                    <el-card>
                      <div class="changeItem">
                        <p style="margin-bottom:10px;">
                          {{Language('处理人')}}：{{ item.userId?optionList['userList'].filter(uItem => { return uItem.userId == item.userId })[0].agentName:'' }}
                        </p>
                        <div class="changeContent" v-if="item.isJson">
                          <p style="padding: 5px 10px;" v-for="(cont, cIndex) in item.content" :key="cIndex">{{cIndex}}：{{cont}}</p>
                        </div>
                        <div class="changeContent" v-else>
                          <p style="padding: 5px 10px;">{{item.content}}</p>
                        </div>
                      </div>
                    </el-card>
                  </el-timeline-item>
                </el-timeline>
              </div>
            </el-tab-pane>
            <el-tab-pane :label="Language('催单记录')" name="2" v-if="editType!='hotline'">
              <div style="padding: 10px 20px;">
                <el-empty :description="Language('暂无记录')" v-if="!reminderRecord.length">
                  <i class="iconfont icongongdan font-36" slot="image" style="color:#909399;"></i>
                </el-empty>
                <el-timeline v-else>
                  <el-timeline-item v-for="(item, index) in reminderRecord" :key="index" type="primary" :timestamp="item.createDate" placement="top">
                    <el-card>
                      <div class="changeItem">
                        <p style="margin-bottom:10px;">
                          {{Language('催单人')}}：{{ item.createOper?optionList['userList'].filter(uItem => { return uItem.userId == item.createOper })[0].agentName:'' }}
                        </p>
                        <div class="changeContent">
                          <p style="padding: 5px 10px;">{{Language('催单内容')}}：{{item.reason}}</p>
                        </div>
                      </div>
                    </el-card>
                  </el-timeline-item>
                </el-timeline>
              </div>
            </el-tab-pane>
            <el-tab-pane :label="Language('回访记录')" name="3" v-if="editType!='hotline'">
              <el-table :data="returnRecord" class="default-button-box" highlight-current-row>
                <el-table-column prop="satType" :label="Language('评价方式')">
                  <template slot-scope="scope">
                    <span>{{Language(scope.row.satType=='1'?'短信':scope.row.satType=='2'?'邮件':scope.row.satType=='3'?'电话':'')}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="isOpenSolved" :label="Language('开启解决')">
                  <template slot-scope="scope">{{ Language(scope.row.isOpenSolved == 1 ? '是' : '否') }}</template>
                </el-table-column>
                <el-table-column prop="isSolved" :label="Language('是否解决')">
                  <template slot-scope="scope">{{ Language(scope.row.isSolved == 1 ? '是' : '否') }}</template>
                </el-table-column>
                <el-table-column prop="satisfied" :label="Language('是否满意')">
                  <template slot-scope="scope">{{ Language(scope.row.satisfied == 1 ? '是' : '否') }}</template>
                </el-table-column>
                <el-table-column prop="name" :label="Language('评价名')"></el-table-column>
                <el-table-column prop="detContent" :label="Language('评价明细')" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="remark" :label="Language('评价描述')" show-overflow-tooltip></el-table-column>
                <el-table-column prop="visitOper" :label="Language('回访人')">
                  <template slot-scope="scope">
                    {{ scope.row.visitOper?optionList['userList'].filter(uItem => { return uItem.userId == scope.row.visitOper })[0].agentName:'' }}
                  </template>
                </el-table-column>
                <el-table-column prop="visitDate" :label="Language('回访时间')" width="160px"></el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane :label="Language('延期记录')" name="4" v-if="editType!='hotline'">
              <el-table :data="delayRecord" class="default-button-box" highlight-current-row>
                <el-table-column prop="reason" :label="Language('延期原因')" show-overflow-tooltip></el-table-column>
                <el-table-column prop="duration" :label="Language('延期时长(h)')"></el-table-column>
                <el-table-column prop="checkRes" :label="Language('审批结果')">
                  <template slot-scope="scope">
                    {{ Language(scope.row.checkRes==0?'待审批':scope.row.checkRes==1?'通过':scope.row.checkRes==2?'未通过':scope.row.checkRes==3?'取消':'') }}
                  </template>
                </el-table-column>
                <el-table-column prop="createOper" :label="Language('申请人')">
                  <template slot-scope="scope">
                    <span>{{formatColumn('createOper', scope.row)}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="createDate" :label="Language('申请时间')" width="160px"></el-table-column>
                <el-table-column :label="Language('操作')" width="100" v-if="editType!='info'&&editType!='return'">
                  <template slot-scope="scope">
                    <el-tooltip :enterable="false" :content="Language('取消')" placement="top">
                      <i class="iconfont iconny-023quxiao table-icon-btn" @click="extensionApplyCancelFn(scope.row)" v-if="scope.row.checkRes==0"></i>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane :label="Language('历史工单')" name="5">
              <el-table :data="historyRecord" class="default-button-box" highlight-current-row>
                <el-table-column prop="title" :label="Language('标题')" show-overflow-tooltip></el-table-column>
                <el-table-column prop="orderTypeCode" :label="Language('工单类型')" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <span>{{formatColumn('orderTypeCode', scope.row)}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="originName" :label="Language('渠道名称')" show-overflow-tooltip></el-table-column>
                <el-table-column prop="status" :label="Language('工单状态')" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <span>{{formatColumn('status', scope.row)}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="priorityCode" :label="Language('优先级')" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <span>{{formatColumn('priorityCode', scope.row)}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="groupName" :label="Language('受理部门')" show-overflow-tooltip></el-table-column>
                <el-table-column prop="userName" :label="Language('受理人')" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createDate" :label="Language('创建时间')" width="160px"></el-table-column>
                <el-table-column :label="Language('操作')" width="90px">
                  <template slot-scope="scope">
                    <el-tooltip :enterable="false" :content="Language('跟进')" placement="top">
                      <el-button type="text" icon="iconfont icongongdanguanli1 table-icon-btn" style="padding: 0;margin:0;" @click="onEditOrder(scope.row, 1)" v-if="scope.row.status!=8"></el-button>
                    </el-tooltip>
                    <el-tooltip :enterable="false" :content="Language('查看')" placement="top">
                      <el-button type="text" icon="iconfont iconchakan1 table-icon-btn" style="padding: 0;margin:0;" @click="onEditOrder(scope.row, 2)"></el-button>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="content-list">
          <div class="customerInfo">
            <p class="infoTitle">
              {{Language('客户信息')}}
              <el-button class="padding5 ml-10" type="primary" plain size="mini" @click="handleSaveFn(1)" v-if="editType!='examine'&&editType!='info'">{{Language('保存')}}</el-button>
              <el-button class="padding5 ml-10" type="info" plain size="mini" @click="handleResetFn(1)" v-if="editType!='examine'&&editType!='info'&&customerInfo.id">{{Language('重置')}}</el-button>
            </p>
            <div class="infoBox">
              <FormData v-if="dialogShow" @saveFn="saveCustomerInfo" :formColumnList="cusColumns" :dialogShow="dialogShow" :sFormInfo="customerInfo" 
                :orderEdit="true" @changeCusInfo="changeCusInfo" ref="orderCusInfo" :editType="editType" :hotlineObj="hotlineObj"></FormData>
            </div>
          </div>
          <div class="companyInfo">
            <p class="infoTitle">
              {{Language('公司信息')}}
              <el-button class="padding5 ml-10" type="primary" plain size="mini" @click="handleSaveFn(2)" v-if="editType!='examine'&&editType!='info'">{{Language('保存')}}</el-button>
              <el-button class="padding5 ml-10" type="info" plain size="mini" @click="handleResetFn(2)" v-if="editType!='examine'&&editType!='info'&&customerPanyInfo.id">{{Language('重置')}}</el-button>
            </p>
            <div class="infoBox">
              <FormData v-if="dialogShow" @saveFn="saveCustomerPanyInfo" :formColumnList="cusPanyColumns" :dialogShow="dialogShow" :sFormInfo="customerPanyInfo"
                :orderEdit="true" @changeCusCompanyInfo="changeCusCompanyInfo" ref="orderCusPanyInfo" :editType="editType"></FormData>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog custom-class="addOperator center-dialog Operator-add new-dialog-box" :title="Language(operateTitle)" width="40%" 
      :visible.sync="operateVisible" :close-on-press-escape="false" :close-on-click-modal="false" :modal-append-to-body="false">
      <el-form :model="operateForm" ref="operateForm" :rules="rules" label-width="80px" class="all-form formStyle" size="small" style="padding: 10px 20px;">
        <!-- 分配 -->
        <div v-if="operateVal==1 || operateVal==10">
          <el-form-item :label="Language('分配人员')" prop="remark">
            <!-- 人员部门选择框 -->
            <DepartPersonSelect ref="DepartPerson"></DepartPersonSelect>
          </el-form-item>
        </div>
        <!-- 延期申请 -->
        <div v-if="operateVal==5">
          <el-form-item :label="Language('延期原因')" prop="reason">
            <el-input type="textarea" v-model="operateForm.reason" :rows="4" :placeholder="Language('请输入延期原因')" maxlength="300" show-word-limit></el-input>
          </el-form-item>
          <el-form-item :label="Language('延期时长')" prop="duration">
            <el-input-number v-model="operateForm.duration" style="width:150px" controls-position="right" :step="0.1" :min="0" step-strictly></el-input-number>&nbsp;&nbsp;小时
          </el-form-item>
        </div>
        <!-- 撤回、催单、驳回、打回 -->
        <div v-if="operateVal==6||operateVal==7||operateVal==8||operateVal==9">
          <el-form-item :label="Language(operateVal==6?'撤回原因':operateVal==7?'催单原因':operateVal==8?'驳回原因':'打回原因')" prop="reason">
            <el-input type="textarea" v-model="operateForm.reason" :rows="4" :placeholder="Language('请输入')+Language(operateVal==6?'撤回原因':operateVal==7?'催单原因':operateVal==8?'驳回原因':'打回原因')" 
              maxlength="300" show-word-limit></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div class="diglog-bom-box">
        <el-button type="primary" size="mini" @click="handleSubmitFn">{{Language('提 交')}}</el-button>
        <el-button @click="operateVisible = false" size="mini">{{Language('取 消')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { orderGetAllRec, orderAddInfo, orderUpdateInfo, orderGetInfo, orderReceiveOrder, orderSetSolved, orderClose, orderSetOper, saveAttList,
    orderExtensionApply, orderRecall, orderReminder, orderReject, orderGetFollowList, orderGetReminderList, orderGetVisitSatisfactionRec, 
    orderGetExtensionRec, orderGetOtherOrderList, rollback, extensionApplyCancel, getButton } from "@/http/orderManagement.js"
  import { customerGetInfo, customerAddInfo, customerUpdateInfo, customerGetList } from "@/http/customerManagement.js"
  import { cusCompanyGetInfo, cusCompanyAddInfo, cusCompanyUpdateInfo, cusCompanyGetList } from "@/http/cusCompanyManagement.js"
  import SearchGet from './SearchGet.vue'
  import TableList from './TableList.vue'
  import OrderForm from './OrderForm.vue'
  import FormData from './FormData.vue'
  import DepartPersonSelect from './DepartPersonSelect.vue'
  import { formatTableData } from '@/utils/auth'

  export default {
    components: { SearchGet, TableList, OrderForm, FormData, DepartPersonSelect },
    props: ['dialogShow', 'editType', 'cusColumns', 'cusPanyColumns', 'orderId', 'examineId', 'returnId', 'fromPage', 'hotlineObj'],
    //editType修改类型 info：查看 add：新增 edit：编辑 examine：审批 supervise：督办 hotline：弹屏
    data() {
      return {
        vdnId: '',
        rules: {},
        operateForm: {}, //工单操作信息表单
        operateVal: '',
        operateVisible: false,
        operateTitle: '', //弹窗标题
        tabsActive: '1',
        returnRecord: [], //回访记录
        delayRecord: [], //延期记录
        historyRecord: [], //历史工单
        followRecord: [], //跟进记录
        reminderRecord: [], //催单记录
        userList: [], //用户列表数据
        optionList: {},
        customerInfo: {}, //客户信息
        customerPanyInfo: {}, //客户公司信息
        isChangeCompany: false, //是否切换公司
        formId: '', //表单id
        sFormInfo: {}, //工单详情信息
        isWait: false,
        buttonList: [],
        btnOption: ['分配', '接单', '解决', '关闭', '延期申请', '撤回', '催单', '驳回', '打回', '转派'],
        statusList: {
          0: '暂存', 1: '开启', 2: '已分配', 3: '处理中', 4: '已解决', 5: '回访中', 6: '待回访', 7: '已回访', 8: '关闭'
        },
      }
    },
    watch: {
      
    },
    mounted() {
      this.vdnId = JSON.parse(LocalStorage.getItem("obj")).vdnId
      this.tabsActive = this.editType=='hotline'?'5':'1'
      this.optionList = JSON.parse(LocalStorage.getItem('optionList'))||{}
      this.userList = this.optionList['userList']
      if (this.editType != 'hotline') this.fetchOrderInfo(this.orderId)
    },
    created() {

    },
    methods: {
      //跟进、查看工单
      onEditOrder(row, type) {
        if (this.fromPage == 'hotline') {
          this.$parent.operateVisible = true
          this.$parent.hdorderId = row.orderId
          if (type == 1) this.$parent.hdeditType = 'edit'
          else this.$parent.hdeditType = 'info'
        } else if (this.fromPage == 'hotlineDialog') {
          if (type == 1) this.$parent.hdeditType = 'edit'
          else this.$parent.hdeditType = 'info'
          this.fetchOrderInfo(row.orderId)
        } else {
          if (type == 1) this.$parent.editType = 'edit'
          else this.$parent.editType = 'info'
          this.fetchOrderInfo(row.orderId)
        }
      },
      //获取工单处理按钮
      getButtonFn(orderId) {
        getButton({
          vdnId: this.vdnId,
          orderId: orderId
        }).then(res => {
          if (res && res.retCode == 1) {
            this.buttonList = res.data
          }
        })
      },
      //取消延期申请
      extensionApplyCancelFn(row) {
        this.$confirm('确定取消该工单的延期申请?', this.Language("提示"), {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          extensionApplyCancel({
            vdnId: this.vdnId,
            id: row.id
          }).then(res => {
            if (res && res.retCode == 1) {
              this.$Msg.success('操作成功');
              this.fetchOrderExtensionRec(this.orderId) //延期记录
            }
          })
        }).catch(() => {})
      },
      formatColumn(name, row) {
        return formatTableData(name, row)
      },
      //选择切换客户信息
      changeCusInfo(obj) {
        this.customerInfo = obj
        this.$refs['sFormInfo'].sForm['cusId'] = obj.id
        this.fetchOrderOtherOrderList(obj.id, '')
        if (obj.cId) this.getCusCompanyInfo(obj.cId)
        else this.customerPanyInfo = {}
      },
      //选择切换公司信息
      changeCusCompanyInfo(obj) {
        this.isChangeCompany = true
        this.customerPanyInfo = obj
        this.customerInfo.cId = obj.id
      },
      //跟进记录
      fetchOrderFollowList(orderId) {
        orderGetFollowList({
          vdnId: this.vdnId,
          orderId: orderId
        }).then(res => {
          if (res && res.retCode == 1) {
            this.followRecord = res.data
            if (this.followRecord.length) {
              this.followRecord.map(item => {
                try {
                  let obj = JSON.parse(item.content)
                  item.content = obj
                  item.isJson = true
                } catch(e) {
                  item.isJson = false
                }
              })
            }
          }
        })
      },
      //催单记录
      fetchOrderReminderList(orderId) {
        orderGetReminderList({
          vdnId: this.vdnId,
          orderId: orderId
        }).then(res => {
          if (res && res.retCode == 1) {
            this.reminderRecord = res.data
          }
        })
      },
      //回访及满意度调查记录
      fetchOrderVisitSatisfactionRec(orderId) {
        orderGetVisitSatisfactionRec({
          vdnId: this.vdnId,
          orderId: orderId
        }).then(res => {
          if (res && res.retCode == 1) {
            this.returnRecord = res.data
          }
        })
      },
      //延期记录
      fetchOrderExtensionRec(orderId) {
        orderGetExtensionRec({
          vdnId: this.vdnId,
          orderId: orderId
        }).then(res => {
          if (res && res.retCode == 1) {
            this.delayRecord = res.data
          }
        })
      },
      //获取工单同一客户历史工单信息
      fetchOrderOtherOrderList(cusId, orderId) {
        orderGetOtherOrderList({
          vdnId: this.vdnId,
          cusId: cusId,
          orderId: orderId,
          pageSize: 999,
          pageNo: 1
        }).then(res => {
          if (res && res.retCode == 1) {
            this.historyRecord = res.data.list
          }
        })
      },
      //获取工单信息信息
      fetchOrderInfo(orderId, type) {
        orderGetInfo({
          vdnId: this.vdnId,
          id: orderId
        }).then(res => {
          if (res && res.retCode == 1) {
            $('.content-form').scrollTop(0)
            this.formId = res.data.formId
            this.sFormInfo = res.data
            if (res.data.cusId) {
              this.getCustomerInfo(res.data.cusId)
              
              this.getButtonFn(orderId) //获取工单处理按钮
              if (!type) {
                this.fetchOrderFollowList(orderId) //跟进记录
                this.fetchOrderReminderList(orderId) //催单记录
                this.fetchOrderVisitSatisfactionRec(orderId) //回访记录
                this.fetchOrderExtensionRec(orderId) //延期记录
              }
              this.fetchOrderOtherOrderList(res.data.cusId, orderId) //历史记录
            }
          }
        })
      },
      //获取客户信息
      getCustomerInfo(id) {
        customerGetInfo({
          vdnId: this.vdnId,
          id: id
        }).then(res => {
          if (res && res.retCode == 1) {
            this.customerInfo = res.data
            if (res.data.cId) {
              this.getCusCompanyInfo(res.data.cId)
            }
          }
        })
      },
      //获取客户公司信息
      getCusCompanyInfo(id) {
        cusCompanyGetInfo({
          vdnId: this.vdnId,
          id: id
        }).then(res => {
          if (res && res.retCode == 1) {
            this.customerPanyInfo = res.data
          }
        })
      },
      //工单页面-客户、公司触发保存信息操作
      handleSaveFn(type) {
        if (type == 1) {
          this.isWait = false
          this.isChangeCompany = false
          this.$refs['orderCusInfo'].saveFn()
        } else this.$refs['orderCusPanyInfo'].saveFn()
      },
      //客户、公司重置信息
      handleResetFn(type) {
        if (type == 1) {
          this.$confirm('确定重置信息？', this.Language("提示"), {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.customerInfo = {}
            this.customerPanyInfo = {}
            this.$refs['sFormInfo'].sForm['cusId'] = ''
            if (this.$refs['orderCusInfo'].$refs) {
              let refsObj = this.$refs['orderCusInfo'].$refs
              for (let key in refsObj) {
                if (key!='sex' && key!='sForm' && key!='labelData') {
                  refsObj[key][0].values = null
                } else {
                  if (key=='labelData') this.$refs['orderCusInfo'].cusLabPath = []
                }
              }
            }
          }).catch(() => {})
        } else {
          this.$confirm('确定重置信息？', this.Language("提示"), {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.customerPanyInfo = {}
            this.customerInfo.cId = ''
          }).catch(() => {})
        }
      },
      //保存客户信息
      saveCustomerInfo(saveObj) {
        if (!this.$refs['orderCusInfo'].sForm['cId']) {
          if (this.$refs['orderCusPanyInfo'].sForm.name) {
            this.isWait = true
            this.$refs['orderCusPanyInfo'].saveFn()
          }
        }
        if (!this.isWait) {
          if (saveObj.id) this.customerUpdateInfoFn(saveObj)
          else this.customerAddInfoFn(saveObj)
        }
      },
      //保存客户公司信息
      saveCustomerPanyInfo(saveObj) {
        if (saveObj.id) this.cusCompanyUpdateInfoFn(saveObj)
        else this.cusCompanyAddInfoFn(saveObj)
      },
      //添加公司
      cusCompanyAddInfoFn(data) {
        let requestData = {}, operateData = []
        for (let fild in data) {
          if (data[fild] instanceof Date)operateData.push({ fieldName: fild, value: this.renderTime(data[fild]) })
          else operateData.push({ fieldName: fild, value: data[fild]||'' })
        }
        requestData['vdnId'] = this.vdnId
        requestData['operateData'] = operateData
        cusCompanyAddInfo(requestData).then(res => {
          if (res && res.retCode == 1) {
            this.$refs['orderCusInfo'].sForm['cId'] = res.data
            this.$refs['orderCusPanyInfo'].sForm['id'] = res.data
            this.cusCompanyGetListFn()
            this.$Msg.success('添加成功');
            if (this.isWait) this.handleSaveFn(1)
          }
        })
      },
      //修改公司
      cusCompanyUpdateInfoFn(data) {
        let requestData = {}, operateData = []
        for (let fild in data) {
          if (data[fild] instanceof Date)operateData.push({ fieldName: fild, value: this.renderTime(data[fild]) })
          else operateData.push({ fieldName: fild, value: data[fild]||'' })
        }
        requestData['vdnId'] = this.vdnId
        requestData['id'] = data.id
        requestData['operateData'] = operateData
        cusCompanyUpdateInfo(requestData).then(res => {
          if (res && res.retCode == 1) {
            this.cusCompanyGetListFn()
            this.$Msg.success('修改成功');
            if (this.isWait || this.isChangeCompany) this.handleSaveFn(1)
          }
        })
      },
      //添加客户
      customerAddInfoFn(data) {
        let requestData = {}, operateData = []
        for (let fild in data) {
          if (data[fild] instanceof Date)operateData.push({ fieldName: fild, value: this.renderTime(data[fild]) })
          else operateData.push({ fieldName: fild, value: data[fild]||'' })
        }
        requestData['vdnId'] = this.vdnId
        requestData['operateData'] = operateData
        customerAddInfo(requestData).then(res => {
          if (res && res.retCode == 1) {
            //设置工单cusId
            this.$refs['sFormInfo'].sForm['cusId'] = res.data
            //设置客户信息id
            this.$refs['orderCusInfo'].sForm['id'] = res.data
            
            this.customerGetListFn()
            this.$Msg.success('添加成功');
            this.isWait = false
          }
        })
      },
      //修改客户
      customerUpdateInfoFn(data) {
        let requestData = {}, operateData = []
        for (let fild in data) {
          if (data[fild] instanceof Date)operateData.push({ fieldName: fild, value: this.renderTime(data[fild]) })
          else operateData.push({ fieldName: fild, value: data[fild]||'' })
        }
        requestData['vdnId'] = this.vdnId
        requestData['id'] = data.id
        requestData['operateData'] = operateData
        customerUpdateInfo(requestData).then(res => {
          if (res && res.retCode == 1) {
            this.customerGetListFn()
            this.$Msg.success('修改成功');
            this.isWait = false
          }
        })
      },
      //客户列表
      customerGetListFn() {
        // queryData
        let queryData = []
        //showData
        let showData = [{ fieldName: 'cusName' }]
        //请求查询接口
        let params = {
          vdnId: this.vdnId,
          pageSize: 999,
          pageNo: 1,
          queryData: queryData,
          showData: showData
        }
        customerGetList(params).then((res) => {
          if (res && res.retCode === 1) {
            let resData = res.data.list.length?res.data.list:[]
            let optionList = JSON.parse(LocalStorage.getItem('optionList'))||{}, customer = []
            resData.map(item => {
              customer.push({ vdnId: item.vdnId, cusName: item.cusName, id: item.id })
            })
            optionList['customer'] = customer
            LocalStorage.setItem('optionList', JSON.stringify(optionList))
          }
        })
      },
      //客户公司列表
      cusCompanyGetListFn() {
        // queryData
        let queryData = []
        //showData
        let showData = [
          {fieldName: "name"},
          {fieldName: "remark"},
          {fieldName: "createOper"},
          {fieldName: "createDate"},
        ]
        //请求查询接口
        let params = {
          vdnId: this.vdnId,
          pageSize: 999,
          pageNo: 1,
          queryData: queryData,
          showData: showData
        }
        cusCompanyGetList(params).then(res => {
          if (res && res.retCode === 1) {
            let resData = res.data.list.length?res.data.list:[]
            let optionList = JSON.parse(LocalStorage.getItem('optionList'))||{}, cusCompany = []
            resData.map(item => {
              cusCompany.push({ vdnId: item.vdnId, name: item.name, id: item.id })
            })
            optionList['cusCompany'] = cusCompany
            LocalStorage.setItem('optionList', JSON.stringify(optionList))
          }
        })
      },
      //关闭页面
      handleClose(type) {
        if (this.fromPage == 'customer'||this.fromPage == 'cusCompany'||this.fromPage == 'order'||this.fromPage == 'hotline'||this.fromPage == 'hotlineDialog') {
          if (this.fromPage == 'customer') {
            this.$parent.editShow = false
            this.$parent.editType = 'edit'
            if (this.$parent.customerShow) this.$parent.$parent.customerShow = false
            this.$parent.fetchComOrderListFn(this.$parent.cusId)
          }
          if (this.fromPage == 'cusCompany') {
            this.$parent.editShow = false
            this.$parent.editType = 'edit'
            this.$parent.fetchComOrderListFn(this.$parent.cId)
          }
          if (this.fromPage == 'order') {
            if (this.$parent.editType == 'add') {
              this.$parent.editShow = false
              this.$parent.editType = 'add'
              this.$parent.fetchOrderOtherOrderList(this.$parent.cusId, '')
            } else {
              this.$parent.editShow = false
              this.$parent.editType = 'edit'
              this.$parent.fetchOrderOtherOrderList(this.$parent.cusId, this.$parent.orderId)
            }
          }
          if (this.fromPage == 'hotline') {}
          if (this.fromPage == 'hotlineDialog') {
            this.$parent.operateVisible = false
          }
        } else {
          this.$parent.dialogShow = false
          if (type==1) this.$parent.fetchTableListFn()
        }
      },
      //创建人格式化
      formatUserFn(userId) {
        let agentName = ''
        if (this.userList.length) {
          this.userList.map(item => {
            if (item.id == userId) agentName = item.agentName
          })
        }
        return agentName
      },
      //工单操作点击
      operateFn(val) {
        this.rules = {}
        this.operateForm = {}
        let btnIndex = this.btnOption.findIndex((value, index, arr) => {
          return (value == val)
        })
        this.operateVal = (btnIndex+1)
        switch((btnIndex+1)) {
          case 1: this.operateTitle = '分配'; this.operateVisible = true; break;
          case 2: this.handleConfimFn(2); break;
          case 3: this.handleConfimFn(3); break;
          case 4: this.handleConfimFn(4); break;
          case 5: 
            this.operateTitle = '延期申请'; 
            this.operateVisible = true; 
            this.operateForm = { duration: 1 }
            this.rules = {
              duration: { required: true, message: this.Language("请输入延期时长")}
            }
            break;
          case 6: this.operateTitle = '撤回'; this.operateVisible = true; break;
          case 7: this.operateTitle = '催单'; this.operateVisible = true; break;
          case 8: this.operateTitle = '驳回'; this.operateVisible = true; break;
          case 9: this.operateTitle = '打回'; this.operateVisible = true; break;
          case 10: this.operateTitle = '转派'; this.operateVisible = true; break;
        }
      },
      //2：接单 3：解决 4：关闭
      handleConfimFn(type) {
        let title = type==2?'确定对该工单进行"接单"操作?':type==3?'确定对该工单标记为"已解决"?':type==9?'确定打回该工单?':'确定关闭该工单?'
        this.$confirm(title, this.Language("提示"), {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if (type==2) this.receiveOrderFn()
          if (type==3) this.setSolvedFn()
          if (type==4) this.closeOrderFn()
        }).catch(() => {})
      },
      //接单
      receiveOrderFn() {
        orderReceiveOrder({
          vdnId: this.vdnId,
          orderId: this.orderId,
          version: this.sFormInfo.version
        }).then(res => {
          if (res && res.retCode === 1) {
            this.$Msg.success('操作成功');
            this.handleClose(1)
          }
        })
      },
      //解决
      setSolvedFn() {
        orderSetSolved({
          vdnId: this.vdnId,
          orderId: this.orderId,
          version: this.sFormInfo.version
        }).then(res => {
          if (res && res.retCode === 1) {
            this.$Msg.success('操作成功');
            this.handleClose(1)
          }
        })
      },
      //关闭工单
      closeOrderFn() {
        orderClose({
          vdnId: this.vdnId,
          orderId: this.orderId,
          version: this.sFormInfo.version
        }).then(res => {
          if (res && res.retCode === 1) {
            this.$Msg.success('操作成功');
            this.handleClose(1)
          }
        })
      },
      //打回工单
      rollbackOrderFn() {
        rollback({
          vdnId: this.vdnId,
          orderId: this.orderId,
          reason: this.operateForm.reason||'',
          version: this.sFormInfo.version
        }).then(res => {
          if (res && res.retCode === 1) {
            this.$Msg.success('操作成功');
            this.operateVisible = false
            this.fetchOrderInfo(this.orderId)
          }
        })
      },
      //工单操作-提交
      handleSubmitFn() {
        if (this.operateVal == 1 || this.operateVal == 10) { //分配
          let groupId = this.$refs['DepartPerson'].orgId[0]||''
          let userId = this.$refs['DepartPerson'].userId||''
          if (!groupId) this.$Msg.error('部门不能为空！')
          else this.orderSetOperFn(groupId, userId)
        } else if (this.operateVal == 5) {//延期申请
          this.$refs['operateForm'].validate((valid) => {
            if (valid) {
              this.orderExtensionApplyFn()
            }
          })
        } else {//撤回、催单、驳回、打回
          if (this.operateVal == 6) this.orderRecallFn()
          if (this.operateVal == 7) this.orderReminderFn()
          if (this.operateVal == 8) this.orderRejectFn()
          if (this.operateVal == 9) this.rollbackOrderFn()
        }
      },
      //分配
      orderSetOperFn(groupId, userId) {
        orderSetOper({
          vdnId: this.vdnId,
          orderId: this.orderId,
          groupId: groupId,
          userId: userId,
          version: this.sFormInfo.version
        }).then(res => {
          if (res && res.retCode === 1) {
            this.$Msg.success('操作成功');
            this.operateVisible = false
            this.handleClose(1)
          }
        })
      },
      //延期申请
      orderExtensionApplyFn() {
        orderExtensionApply({
          ...this.operateForm,
          vdnId: this.vdnId,
          orderId: this.orderId,
          version: this.sFormInfo.version
        }).then(res => {
          if (res && res.retCode === 1) {
            this.$Msg.success('操作成功');
            this.operateVisible = false
            this.fetchOrderInfo(this.orderId)
          }
        })
      },
      //撤回
      orderRecallFn() {
        orderRecall({
          vdnId: this.vdnId,
          orderId: this.orderId,
          reason: this.operateForm.reason||'',
          version: this.sFormInfo.version
        }).then(res => {
          if (res && res.retCode === 1) {
            this.$Msg.success('操作成功');
            this.operateVisible = false
            this.fetchOrderInfo(this.orderId)
          }
        })
      },
      //催单
      orderReminderFn() {
        orderReminder({
          vdnId: this.vdnId,
          orderId: this.orderId,
          reason: this.operateForm.reason||'',
          version: this.sFormInfo.version
        }).then(res => {
          if (res && res.retCode === 1) {
            this.$Msg.success('操作成功');
            this.operateVisible = false
            this.fetchOrderInfo(this.orderId)
          }
        })
      },
      //驳回
      orderRejectFn() {
        orderReject({
          vdnId: this.vdnId,
          orderId: this.orderId,
          reason: this.operateForm.reason||'',
          version: this.sFormInfo.version
        }).then(res => {
          if (res && res.retCode === 1) {
            this.$Msg.success('操作成功');
            this.operateVisible = false
          }
        })
      },
      saveFn(data, fileList) {
        let files = fileList?fileList:'', operateData = [], isUpload = (files.length)?true:false
        for (let fild in data) {
          if (fild != 'id' && data[fild]) {
            if (data[fild] instanceof Date) operateData.push({ fieldName: fild, value: this.renderTime(data[fild]) })
            else if (fild == 'labMsg'|| fild == 'LabPath') {
              operateData.push({ fieldName: fild, value: data[fild]?data[fild].join(','):'' })
            }
            else operateData.push({ fieldName: fild, value: data[fild]||'' })
          }
        }
        if (this.editType == 'edit' || this.editType == 'supervise') {
          this.orderUpdateInfoFn(files, operateData, isUpload)
        } else if (this.editType == 'add') {
          this.orderAddInfoFn(files, operateData, isUpload)
        } else if (this.editType == 'hotline') {
          this.$refs['sFormInfo'].submitLoading = true
          if (this.$refs['sFormInfo'].isHotlineSubmit) this.orderUpdateInfoFn(files, operateData, isUpload, 'hotline')
          else this.orderAddInfoFn(files, operateData, isUpload, 'hotline')
        }
      },
      //修改工单
      orderUpdateInfoFn(fileList, operateData, isUpload, type) {
        let requestData = {}
        requestData['vdnId'] = this.vdnId
        requestData['id'] = this.sFormInfo.orderId
        requestData['version'] = this.sFormInfo.version
        requestData['operateData'] = operateData
        orderUpdateInfo(requestData).then(res => {
          if (res && res.retCode == 1) {
            if (isUpload&&fileList) this.saveAttListFn(this.sFormInfo.orderId, fileList)
            this.$Msg.success('修改成功');
            this.$refs['sFormInfo'].submitLoading = false
            if (type == 'hotline') {
              this.fetchOrderInfo(this.sFormInfo.orderId, 'hotline')
            } else this.handleClose(1)
          } else this.$refs['sFormInfo'].submitLoading = false
        }).catch(err => { this.$refs['sFormInfo'].submitLoading = false })
      },
      //新建工单
      orderAddInfoFn(fileList, operateData, isUpload, type) {
        let requestData = {}
        requestData['vdnId'] = this.vdnId
        requestData['operateData'] = operateData
        orderAddInfo(requestData).then(res => {
          if (res && res.retCode == 1) {
            if (isUpload&&fileList) this.saveAttListFn(res.data, fileList)
            this.$Msg.success('添加成功');
            this.$refs['sFormInfo'].submitLoading = false
            if (type == 'hotline') {
              this.fetchOrderInfo(res.data, 'hotline')
              this.$refs['sFormInfo'].isHotlineSubmit = true
            } else this.handleClose(1)
          } else this.$refs['sFormInfo'].submitLoading = false
        }).catch(err => { this.$refs['sFormInfo'].submitLoading = false })
      },
      saveAttListFn(orderId, fileList) {
        saveAttList({
          vdnId: this.vdnId,
          orderId: orderId,
          attList: fileList
        }).then(res => {
          if (res && res.retCode == 1) {}
        })
      },
    }
  }
</script>

<style scoped lang="scss">
.diglog-bom-box{
  padding: 15px 0 15px 20px;
}
.orderEdit{
  height: 100%;
}
.orderForm{
  padding: 0 10px;
}
.pageNav {
  border-bottom: #e9e9e9 1px solid;
  padding: 0 0 15px 0;
  position: relative;
}
.goBack {
  border: 1px solid #8E96AB52;
  cursor: pointer;
}
.goBack,
.breadcrumb {
  vertical-align: middle;
  display: inline-block;
  font-weight: bold;
}
.operateList{
  position: absolute;
  right: 37%;
  top: 0;
  li{
    background: #fff;
    border: 1px solid #e9e9e9;
    padding: 3px 20px;
    float: left;
    font-size: 12px;
    cursor: pointer;
    &:hover{
      background: #ecf5ff;
      border-color: #c6e2ff;
      color: #409EFF;
    }
  }
}
.contentBox{
  display: flex;
  height: calc(100% - 35px);
  .content-form{
    flex: 2.2;
    margin-right: 10px;
    width: calc(100% - 10px);
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    .el-form-item{
      margin-bottom: 10px;
    }
  }
  .content-list{
    flex: 1.2;
    margin-left: 10px;
    width: 100%;
    height: 100%;
    .customerInfo,
    .companyInfo{
      border: 1px solid #e9e9e9;
      .infoTitle{
        border-bottom: 1px solid #e9e9e9;
        padding: 10px 20px;
        font-weight: bold;
      }
      .infoBox{
        height: calc(100% - 65px);
        overflow-x: hidden;
        overflow-y: auto;
        padding: 10px;
      }
    }
    .customerInfo{
      height: 60%;
    }
    .companyInfo{
      margin-top: 10px;
      height: 40%;
    }
  }
}
.notRight{
  min-height: calc(100% - 455px);
}
.notRight >>> .el-tabs__nav{
  width: 20%;
  padding: 0;
}
.notRight >>> .el-tabs__item {
  width: 50%;
  padding: 0;
  margin: 0;
  text-align: center;
}
.changeContent{
  background-color: #f7f8fa;
}
</style>



// WEBPACK FOOTER //
// OrderEdit.vue?34f0c1be